/*
 * @Autor: lh
 * @Date: 2022-03-23 17:43:27
 * @LastEditors: lh
 * @LastEditTime: 2023-11-20 17:16:58
 * @Description:
 */
import Vue from 'vue'
import 'vant/lib/index.css';
// import Vant from 'vant';

import {
    Button,
    Field,
    Dialog,
    Icon,
    Swipe,
    SwipeItem,
    List,
    Empty,
    Tab,
    Tabs,
    Cell,
    CellGroup,
    Switch,
    RadioGroup,
    Radio,
    Lazyload,
    // Uploader,
    DatetimePicker,
    Popup,
    Area,
    CountDown,
    NoticeBar,
    PullRefresh,
    Overlay,
    Loading,
    Stepper,
    Form,
    ContactCard ,
    AddressList,
    AddressEdit ,

} from 'vant';

Vue.use(AddressEdit);
Vue.use(AddressList);
Vue.use(ContactCard);
Vue.use(Overlay);
// Vue.use(Vant);
Vue.use(PullRefresh);
Vue.use(NoticeBar);
Vue.use(CountDown);
Vue.use(Lazyload);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Button);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(List);
Vue.use(Empty);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Switch);
Vue.use(Radio);
Vue.use(RadioGroup);
// Vue.use(Uploader);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Loading);
Vue.use(Stepper);
Vue.use(Form)



// WEBPACK FOOTER //
// ./src/static/js/vantUi.js